<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add District</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="district.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Postal Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="district.postal_code" />
                                    <validation-error :errors="apiValidationErrors.postal_code"  />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Region
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="district.region_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="District Type"
                                        placeholder="Select Regions"
                                        :options="available_regions_dropdown"
                                        :allow-empty="false">
                                </select-input>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                District Type
                            </label>
                            <div class="md-layout-item">
                                <select-input
                                        v-model="district.district_type_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="District Type"
                                        placeholder="Select District"
                                        :options="available_districts_dropdown"
                                        :allow-empty="false">
                                </select-input>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add District</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '../../../components/Inputs/SelectInput';
export default {
    components: { ValidationError, SelectInput },

    mixins: [formMixin],

    data () {
        return  {
            district: {
                type:'districts',
                name:null,
                postal_code:null,
                district_type_id: null,
                region_id: null
            },
            available_regions_dropdown: [],
            available_districts_dropdown: [],
        };
    },
    created ()  {
        this.getRegionsDropDowns();
        this.getTypesDropDowns();
        this.get();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('districts/add',  this.district);
                this.notifySuccess('District added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        async getRegionsDropDowns () {
            await this.$store.dispatch('regions/list');
            this.available_regions_dropdown =  await this.$store.getters['regions/list'];
        },
        async  getTypesDropDowns () {
            await this.$store.dispatch('districtTypes/list');
            this.available_districts_dropdown =  await this.$store.getters['districtTypes/list'];
        },

        goBack () {
            this.$router.push({ name: 'Districts List' });
        },
    },

};
</script>
